import React from 'react';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { CorrectionsFormLayout } from './CorrectionsFormLayout';

const metaOverrideSet = buildFacetDesignOverride();

export const CorrectionsForm = ({ collection }) => {
  if (!collection) {
    return null;
  }

  return (
    <MetaCollectionFormInline
      padding="none"
      collection={collection}
      FormProps={{
        layout: CorrectionsFormLayout,
        noIndividualSubmitButtons: true,
      }}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

CorrectionsForm.propTypes = {
  collection: PropTypes.object.isRequired,
};
